import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const InstitutionForgotPasswordDirective = angularDirectiveToReact('forgotPassword', {
    urlPrefix: 'urlPrefix',
});

export function InstitutionForgotPasswordComponent() {
    const [key, params] = useAngularToReactRoute<{ urlPrefix: string }>();
    return <InstitutionForgotPasswordDirective key={key} {...params} />;
}
